import React, { ReactElement } from 'react';
import ActionButtonsContainer from '../ActionButtons/ActionButtonsContainer';
import { IMenuBar } from './constants/MenuBar.interface';
import cn from 'utils/cn';

const MenuBar: React.FC<IMenuBar> = ({
  label = '',
  labelProps = {},
  mode = 'accent',
  variant = 'dark',
  testId = '',
  className = '',
  actionButtons = [],
  style = {},
  paddingLeft = true,
  actionButtonsClassName,
}): ReactElement<any> => {
  return (
    <div
      className={cn(
        `b--shade-dark-25 tw:border-t tw:border-b tw:font-normal tw:overflow-hidden tw:flex tw:h-[40px] tw:items-center tw:justify-between`,
        mode === 'accent' || mode === 'shade' ? 'tw:text-primary-100' : 'tw:text-secondary-400',
        `bg-${mode}-${variant}`,
        className,
        paddingLeft && 'tw:pl-6'
      )}
      data-testid={testId}
      style={{ ...style }}
    >
      <div {...labelProps} className={cn('tw:truncate', labelProps?.className)}>
        {label}
      </div>
      <ActionButtonsContainer
        actionButtons={actionButtons}
        actionButtonsClassName={actionButtonsClassName}
      />
    </div>
  );
};

export default MenuBar;
